module.exports = __webpack_public_path__ + "img/sevice-1.438c9ddb.gif";